<template>
    <!-- FILTRO ZONA -->
    <div class="filter-group">
        <div class="form-check">
            <input class="form-check-input" type="checkbox" :id="checkboxId" v-model="localShowZona"
                @change="handleShowZonaChange" />
            <label class="form-check-label" :for="checkboxId"> Zona </label>
        </div>
        <div :hidden="!localShowZona" class="form-text">
            <label class="form-text-label" for="flexTextDefault"> Lat </label>
            <input class="form-number-input" type="number" v-model="localLatZona" @change="handleLatChange" />
            <label class="form-text-label" for="flexTextDefault"> Lon </label>
            <input class="form-number-input" type="number" v-model="localLonZona" @change="handleLonChange" />

            <label class="form-text-label" for="flexTextDefault"> Radio </label>
            <input class="form-number-input" type="number" v-model="localRadZona" @change="handleRadChange" />

            <!-- Botón para pegar coordenadas del clipboard -->
            <button class="btn btn-sm btn-paste-coords" @click="pasteCoordinatesFromClipboard"
                :disabled="!hasClipboardCoordinates" title="Pegar coordenadas copiadas">
                <i class="bi bi-clipboard-plus me-1"></i>Pegar
            </button>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useGlobalStore } from '@/stores/global'

// Props
const props = defineProps<{
    showZona: boolean
    latZona: string
    lonZona: string
    radZona: string
    checkboxId?: string
}>()

// Emits
const emit = defineEmits<{
    (event: 'update:showZona', value: boolean): void
    (event: 'update:latZona', value: string): void
    (event: 'update:lonZona', value: string): void
    (event: 'update:radZona', value: string): void
    (event: 'filterChanged'): void
}>()

// Store
const globalStore = useGlobalStore()

// Variables locales reactivas
const localShowZona = ref(props.showZona)
const localLatZona = ref(props.latZona)
const localLonZona = ref(props.lonZona)
const localRadZona = ref(props.radZona)

// Computed
const hasClipboardCoordinates = computed(() => {
    return globalStore.getClipboardCoordinates() !== null
})

const checkboxId = computed(() => {
    return props.checkboxId || 'showZona'
})

// Watchers para sincronizar props con variables locales
watch(() => props.showZona, (newVal) => {
    localShowZona.value = newVal
})

watch(() => props.latZona, (newVal) => {
    localLatZona.value = newVal
})

watch(() => props.lonZona, (newVal) => {
    localLonZona.value = newVal
})

watch(() => props.radZona, (newVal) => {
    localRadZona.value = newVal
})

// Handlers
const handleShowZonaChange = () => {
    emit('update:showZona', localShowZona.value)
    emit('filterChanged')
}

const handleLatChange = () => {
    emit('update:latZona', localLatZona.value)
    emit('filterChanged')
}

const handleLonChange = () => {
    emit('update:lonZona', localLonZona.value)
    emit('filterChanged')
}

const handleRadChange = () => {
    emit('update:radZona', localRadZona.value)
    emit('filterChanged')
}

// Función para pegar coordenadas del clipboard
const pasteCoordinatesFromClipboard = () => {
    const clipboardCoords = globalStore.getClipboardCoordinates()
    if (clipboardCoords) {
        localLatZona.value = clipboardCoords.lat.toString()
        localLonZona.value = clipboardCoords.lon.toString()

        // Emitir los cambios
        emit('update:latZona', localLatZona.value)
        emit('update:lonZona', localLonZona.value)
        emit('filterChanged')

        console.log(`📋 Coordenadas pegadas en filtro zona: ${clipboardCoords.lat}, ${clipboardCoords.lon} (desde ${clipboardCoords.source})`)
    }
}
</script>

<style scoped>
.filter-group {
    margin-bottom: 1rem;
}

.form-check {
    margin-bottom: 0.5rem;
}

.form-text {
    display: flex;
    align-items: center;
    gap: 5px;
    flex-wrap: wrap;
}

.form-text-label {
    font-size: 14px;
    color: #6c757d;
    margin: 0;
    white-space: nowrap;
}

.form-number-input {
    width: 80px;
    padding: 2px 5px;
    border: 1px solid #ced4da;
    border-radius: 3px;
    font-size: 12px;
}

.btn-paste-coords {
    background-color: #28a745;
    border-color: #28a745;
    color: white;
    margin-left: 10px;
    padding: 4px 8px;
    font-size: 12px;
    border-radius: 3px;
    transition: all 0.2s ease;
    vertical-align: top;
}

.btn-paste-coords:hover:not(:disabled) {
    background-color: #218838;
    border-color: #1e7e34;
    color: white;
}

.btn-paste-coords:disabled {
    background-color: #6c757d;
    border-color: #6c757d;
    color: #fff;
    opacity: 0.5;
    cursor: not-allowed;
}

.btn-paste-coords:active:not(:disabled) {
    transform: scale(0.98);
}
</style>
